import { Link } from "react-router-dom";
import Logo from '../images/logo.svg';
import Email from '../images/ic_mail.svg'
import Phone from '../images/ic_phone.svg'
import FB from '../images/ic_fb.svg'
import Inst from '../images/ic_inst.svg'
import Location from '../images/ic_location.svg'

const Footer = () => {
  return (
    <div className="mt-[40px]">
    <div className="space-y-6 px-10 lg:px-[20px] xl:px-[100px] py-[20px] flex flex-col lg:flex-row items-start justify-around">
      <div className="flex flex-col items-center -ml-[20px]">
        <Link to="/">
          <img alt="svg" src={Logo} />
        </Link>
      </div>
      <div className="flex gap-x-4 items-start">
        <img alt="svg" src={Location}/>
        <div className="text-2xl text-[#3E3838] space-y-[6px] font-normal font-customFontNew">
          <p>Kievyan St. 2nd Lane,</p>
          <p> 12 House</p>
        </div>
      </div>
      <div className="flex gap-x-4 items-start">
        <img alt="svg" src={Phone}/>
        <div className="text-2xl text-[#3E3838] space-y-[6px] font-normal font-customFontNew">
          <p>+374-98-365366</p>
          <p>+374-91-365366</p>
        </div>
      </div>
      <div className="flex gap-x-4 items-start">
        <img alt="svg" src={Email}/>
        <div className="text-2xl text-[#3E3838] space-y-[6px] font-normal font-customFontNew">
          <p>example@mail</p>
        </div>
      </div>
      <div className="flex gap-x-4 flex-col">
        <p className="text-2xl text-[#3E3838] font-normal font-customFontNew">Follow Us</p>
        <div className="flex gap-x-6  space-y-[6px]">
          <img alt="svg" src={FB}/>
          <img alt="svg" src={Inst}/>
        </div>
      </div>
    </div>
      <div className="flex justify-center w-full bg-[#F6F6F6]">
          <div className="text-[#3B434E] flex flex-col md:flex-row gap-x-4 py-4">
            <p>Copyright ©2024 Powered by 365 travelling</p>
          </div>
      </div>
    </div>
  )
}

export default Footer
